<template>
  <div>
    <!-- <div class="pb-3">
      <div class="d-flex justify-content-between font-weight-bolder py-1">
        <div>Stock Order Progress</div>
        <div>{{ percentage }}%</div>
      </div>
      <BProgress
        :value="percentage"
        max="100"
      />
    </div> -->
    <div class="pl-4">
      <ul class="iq-timeline">
        <slot
          name="approvals"
          v-bind="{
            stage: stockRequest?.stage || 0,
            status: stockRequest?.status || 'Pending',
            created_at: stockRequest?.created_at || '',
            document_number: stockRequest.references?.document_number || '',
            transfer_number: stockRequest.references?.transfer_number || ' ',
            sap_doc_entry: stockRequest.references?.sap_doc_entry || '',
            transaction_number: stockRequest.references?.transaction_number || '',
            approvals: stockRequest?.approvals || []
          }"
        />
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VTimeline',

  props: {
    stockRequest: {
      type: Object,
      default: () => ({
        stage: 0,
        status: '',
        created_at: '',
        references: {
          document_number: '',
          transfer_number: '',
          sap_doc_entry: '',
          transaction_number: ''
        },
        approvals: []
      }),
      required: true
    }
  },

  computed: {
    percentage () {
      return Math.floor(
        (
          this.stockRequest.approvals.filter(
            approver => [
              'Approved',
              'Dispatched',
              'Scheduled',
              'Posted',
              'Received',
              'Closed'
            ].includes(approver.status)
          ).length / this.stockRequest.approvals.length
        ) * 100
      )
    }
  }
}
</script>
